import axios from 'axios';
import Cookies from 'universal-cookie';

const initialState = {
    plans: [],
};

// Action Types
const GET_PLANS = 'GET_PLANS';
const POST_PLAN = 'POST_PLAN';
const UPDATE_PLAN = 'UPDATE_PLAN';
const DELETE_PLAN = 'DELETE_PLAN';

// Reducer
export default function SubscriptionPlansReducer(state = initialState, action) {
    switch (action.type) {
        case GET_PLANS:
            return { ...state, plans: action.payload };
        case POST_PLAN:
            return { ...state, plans: [...state.plans, action.payload] };
        case UPDATE_PLAN:
            return {
                ...state,
                plans: state.plans.map(p =>
                    p.id === action.payload.id ? { ...p, ...action.payload } : p
                ),
            };
        case DELETE_PLAN:
            return {
                ...state,
                plans: state.plans.map(p =>
                    p.id === action.payload ? { ...p, active: false } : p
                ),
            };
        default:
            return state;
    }
}

// Action Creators
export const SetPlans = (plans) => ({ type: GET_PLANS, payload: plans });
export const PostPlan = (plan) => ({ type: POST_PLAN, payload: plan });
export const UpdatePlan = (plan) => ({ type: UPDATE_PLAN, payload: plan });
export const DeletePlan = (id) => ({ type: DELETE_PLAN, payload: id });

const getHeaders = () => {
    const cookies = new Cookies();
    return { headers: { Authorization: `Bearer ${cookies.get('token')}` } };
};

// Thunks (proxy /api/admin/subscription-plans en EasyLawyer → SDK Billing)
export const fetchPlansFromAPI = () => async (dispatch) => {
    try {
        const response = await axios.get(window.API_BASE_URL + '/admin/subscription-plans', getHeaders());
        dispatch(SetPlans(response.data));
    } catch (error) {
        console.error('Error fetching subscription plans:', error);
    }
};

export const createPlanInAPI = (plan) => async (dispatch) => {
    try {
        const response = await axios.post(window.API_BASE_URL + '/admin/subscription-plans', plan, getHeaders());
        dispatch(PostPlan(response.data));
    } catch (error) {
        console.error('Error creating subscription plan:', error);
    }
};

export const updatePlanInAPI = (id, plan) => async (dispatch) => {
    try {
        const response = await axios.put(`${window.API_BASE_URL}/admin/subscription-plans/${id}`, plan, getHeaders());
        dispatch(UpdatePlan(response.data));
    } catch (error) {
        console.error('Error updating subscription plan:', error);
    }
};

export const deletePlanFromAPI = (id) => async (dispatch) => {
    try {
        await axios.delete(`${window.API_BASE_URL}/admin/subscription-plans/${id}`, getHeaders());
        dispatch(DeletePlan(id));
    } catch (error) {
        console.error('Error deleting subscription plan:', error);
    }
};
